import React, { useState } from "react";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import FormattedDate from "../../../components/TimeStamp";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";

const KhasraDetailsLog = ({ logData }) => {
  console.log("logDataKhasra", logData);

  const detailsArray = Array.isArray(logData) ? logData : [logData];
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const openPopup = (item) => {
    setPopupData(item);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupData(null);
  };

  const printPopup = () => {
    const popupContent = document.getElementById("khasra-popup-print");
    if (!popupContent) return;

    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Khasra Details</title>
          <style>
            body { font-size: 12px; font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; }
            th { background-color: #f0f0f0; }
          </style>
        </head>
        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <div>
      <h3 style={{ fontWeight: "bold", marginBottom: "10px" }}>Khasra Details Log</h3>
      <div style={{ overflowX: "auto", maxHeight: "300px", overflowY: "scroll" }}>
        <table
          border="1"
          cellPadding="8"
          width="100%"
          style={{
            borderCollapse: "collapse",
            minWidth: "600px",
            fontSize: "11px",
            position: "relative",
          }}
        >
          <thead style={{ backgroundColor: "rgba(52, 73, 94, 0.94)", position: "sticky", top: 0, zIndex: 2 }}>
            <tr style={{ fontSize: "14px", backgroundColor: "rgba(52, 73, 94, 0.94)", color: "#fff" }}>
              <th>Designation</th>
              <th>Name</th>
              <th>Date & Time</th>
              <th>Comments</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {detailsArray.map((item, index) => {
              const user = item?.userDetails || {};
              const createdTime = item?.auditDetails?.createdTime || null;
              const remarks=item?.khasraRemarks;
              return (
                <tr key={index}>
                  <td>{user?.designation || "-"}</td>
                  <td>{user?.employeeName || user?.name || "-"}</td>
                  <td>
                    <FormattedDate timestamp={createdTime} />
                  </td>
            
                     <SafeHtml html={remarks || "-"} tag="td"/>

                  <td>
                    <IconButton onClick={() => openPopup(item)} size="small">
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Popup */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: "15%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "20px",
            zIndex: 1000,
            maxHeight: "80vh",
            overflowY: "auto",
            width: "60%",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            fontSize: "12px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>Khasra Details Info</h3>
            <div>
              <IconButton onClick={printPopup} title="Print">
                <PrintIcon />
              </IconButton>
              <IconButton onClick={closePopup} title="Close">
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <div id="khasra-popup-print">
            {popupData?.userDetails && (
              <div style={{ marginBottom: "10px" }}>
                <strong>User:</strong> {popupData.userDetails?.employeeName || popupData.userDetails?.name || "-"} | <strong>Designation:</strong>{" "}
                {popupData.userDetails?.designation || "-"} | <strong>Created:</strong>{" "}
                <FormattedDate timestamp={popupData.auditDetails?.createdTime} />
              </div>
            )}

            <table border="1" cellPadding="6" width="100%" style={{ borderCollapse: "collapse", fontSize: "12px" }}>
              <thead style={{ backgroundColor: "#e2e8f0" }}>
                <tr>
                  <th>Tehsil</th>
                  <th>Village</th>
                  <th>Khasra Number</th>
                  <th>Land Use</th>
                  <th>Comments</th>
                </tr>
              </thead>
              <tbody>
                {(popupData?.khasraDetails || []).map((khasra, i) => (
                  <tr key={i}>
                    <td>{khasra?.tehsil || "-"}</td>
                    <td>{khasra?.villageName || "-"}</td>
                    <td>{khasra?.khasraNumber || "-"}</td>
                    <td>{khasra?.landUse || "-"}</td>
                    <td>{popupData?.khasraRemarks ? <SafeHtml html={popupData.khasraRemarks} /> : "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default KhasraDetailsLog;
